import { createContext, useContext, useEffect, useRef, useState } from 'react'

import './MenuButton.css'

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Menu } from '@/components/Icons'

const BareButton = styled.button`
  border: 0;
  cursor: pointer;
  background: transparent;
  display: grid;
  align-content: center;
  justify-content: center;
  min-width: 22px;
`

const MenuButtonContext = createContext<any>(undefined)

const MenuButton = ({ children, className, menuIcon, label }: any) => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonref = useRef<HTMLButtonElement>(null)
  const menuref = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: any) => {
    const domNode = menuref.current
    if (
      !domNode ||
      !domNode.contains(event.target) ||
      (buttonref.current && buttonref.current.contains(event.target))
    ) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  const handleClick = (e: any) => {
    e.stopPropagation()
    setIsOpen(!isOpen)
  }

  const onHideMenu = () => {
    setIsOpen(false)
  }

  return (
    <MenuButtonContext.Provider value={{ onHideMenu }}>
      <div className={`menuButton ${className || ''}`} role="button" tabIndex={0} onClick={handleClick}>
        {isOpen && (
          <div ref={menuref} className="menuButton-menu">
            {children}
          </div>
        )}
        <BareButton ref={buttonref} aria-label={label} data-testid={'menu-btn'}>
          {menuIcon || <Menu className={isOpen ? 'menu-button-icon-selected' : ''} />}
        </BareButton>
      </div>
    </MenuButtonContext.Provider>
  )
}

const useMenuButtonContext = () => {
  const context = useContext(MenuButtonContext)
  if (!context) throw new Error('useMenuButtonContext must be used within a MenuButton')
  return context
}

MenuButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  menuIcon: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  label: PropTypes.string
}

MenuButton.defaultProps = {
  className: '',
  menuIcon: null,
  children: null,
  label: 'Open Menu'
}

MenuButton.displayName = 'MenuButton'

export { useMenuButtonContext }

export default MenuButton
